/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsVideo = {
    init: function ($section) {
      var $ = window.jQuery || window.$;
      if (!($ && $.fn && typeof $.extend === 'function')) {
        console.error('jQuery is unavailable for jsVideo init.');
        return;
      }

      // Add settings from schema to current object
      Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData($section));

      // Selectors
      const $videoElement = $section.find('[data-video-element]');
      const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');
      const $imageElement = $section.find('[data-image-element]');

      // Load video if the media has been added
      if (this.iframe_video || this.html5_video) {
        this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
      } else {
        $imageElement.show();
      }
    },

    loadVideo: function($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
      const player = new Plyr(`.video-${this.id}`, {
        controls: videoControls,
        hideControls: false,
        loop: {
          active: this.autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });

      player.muted = this.mute;
      player.ratio = this.aspect_ratio;

      if (player && player.elements && player.elements.container) {
        player.elements.container.classList.remove('plyr--hide-controls');
      }
      if (player && player.elements && player.elements.controls) {
        player.elements.controls.style.opacity = 1;
        player.elements.controls.style.pointerEvents = 'auto';
      }

      // If autoplay enabled, hide image and text
      if (this.autoplay) {
        console.dir('has autoplay');
        player.autoplay = true;
        $imageElement.hide();
        // $videoTextContainer.hide();
        $videoTextContainer.show();
        $videoElement.show();
      } else {
        // If autoplay disabled, check if poster image added
        if (this.poster) {
          $videoElement.hide();
          $imageElement.show();
          $videoTextContainer.show();
        } else {
          // If autoplay disabled and no poster image
          $imageElement.hide();
          $videoElement.show();
          $videoTextContainer.show();
        }
      }

      // If button exists, clicking button will play video
      if (this.button) {
        $playButton.on('click', () =>  {
          player.play();
        });
      }

      // Clicking anywhere on video should play the video
      if (!this.button) {
        $videoTextContainer.on('click', () => {
          player.play();
        });
      }

      // If on mobile and text is below image, clicking the image wrapper should play the video
      if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $imageElement.on('click', () => {
          player.play();
        });
      }

      // On player ready, hide play icon if play button visible
      player.on('ready', function() {
        if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
          $playIcon.show();
        } else if ($playButton) {
          $playIcon.hide();
        } else {
          $playIcon.show();
        }

        if (player && player.elements && player.elements.container) {
          player.elements.container.classList.remove('plyr--hide-controls');
        }
        if (player && player.elements && player.elements.controls) {
          player.elements.controls.style.opacity = 1;
          player.elements.controls.style.pointerEvents = 'auto';
        }
      });

      // On play, hide image/text and show video element
      player.on('play', function(index, player) {
        $videoElement.show();
        $imageElement.hide();
        // $videoTextContainer.hide();
      });

      // On player pause, show play icon if play button hidden
      player.on('pause', function(index, player) {
        if (!$playButton) {
          $playIcon.show();
        }
      });

      //
      // ────── RESPONSIVE SOURCE SWAP ON RESIZE ──────────────────────────────────────
      //

      // Grab the actual <video> DOM element inside $videoElement
      const videoTag = $videoElement.find('video')[0];
      if (!videoTag) return;

      // Attempt to find mobile vs desktop <source> elements by their media attribute
      const mobileSrcEl = videoTag.querySelector('source[media*="max-width"]');
      const desktopSrcEl = videoTag.querySelector('source[media*="min-width"]');

      // Helper: are we currently in “mobile” viewport?
      function isMobileViewport() {
        return window.innerWidth <= 767;
      }

      // Determine which source URL we want given current viewport
      function getDesiredSourceURL() {
        // If there is no mobile source defined, always return desktop
        if (!mobileSrcEl) {
          return desktopSrcEl ? desktopSrcEl.getAttribute('src') : null;
        }
        // If mobile and a mobile <source> exists, use it, otherwise fallback to desktop
        return isMobileViewport()
          ? mobileSrcEl.getAttribute('src')
          : (desktopSrcEl ? desktopSrcEl.getAttribute('src') : null);
      }

      // Swap <video>’s <source> on resize if viewport crosses the breakpoint
      function swapVideoOnResize() {
        const currentURL = videoTag.currentSrc || videoTag.src;
        const desiredURL = getDesiredSourceURL();

        // If desiredURL is null or already playing the correct file, do nothing
        if (!desiredURL || currentURL === desiredURL) {
          return;
        }

        // Remove all existing <source> children
        while (videoTag.firstChild) {
          videoTag.removeChild(videoTag.firstChild);
        }

        // Create and append exactly one <source> with the desired URL
        const newSource = document.createElement('source');
        newSource.setAttribute('src', desiredURL);
        newSource.setAttribute('type', 'video/mp4');
        videoTag.appendChild(newSource);

        // Force the <video> to load the new <source>
        videoTag.load();
        videoTag.play().catch(() => {
          // iOS or other browsers may still block autoplay if not muted/playsinline
        });
      }

      // Throttle mechanism for resize event
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(swapVideoOnResize, 200);
      });

      // Also run once on initial load in case JS needs to “correct” which source is inserted
      swapVideoOnResize();
      //
      // ──────────────────────────────────────────────────────────────────────────────
      //
    },

    unload: function($section) {
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');

      $playButton.off();
      $videoTextContainer.off();
    }
  }
/******/ })()
;
